/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import { Card, CardContent, Grid, makeStyles, Typography } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import { Checkbox } from '@mui/material';
import Image from '../common/Image';
import { CustomMenu } from './CustomMenu';
import Theme from '../ui/Theme';

const useStyles = makeStyles({
  root: {
    minWidth: 220,
    marginBottom: '8px',
    width: ({ width }) => width || '492px',
    height: ({ height }) => height || '72px',
    borderRadius: '8px',
    borderColor: ({ grey, clicked }) => (clicked ? '#BEB3FF' : grey ? Theme.palette.secondary.main : '#E4E7EC'),
    backgroundColor: ({ grey, disabled, clicked }) =>
      disabled ? 'rgba(211, 211, 211, 0.6)' : clicked ? '#F4F3FF' : grey ? Theme.palette.secondary.main : '#FFF',
    opacity: ({ disabled }) => (disabled ? 0.6 : 1),
    pointerEvents: ({ disabled }) => (disabled ? 'none' : 'auto'),
  },
  thumbnail: {
    width: ({ thumbnailSize }) => thumbnailSize || '52px',
    height: ({ thumbnailSize }) => thumbnailSize || '52px',
    borderRadius: '4px',
  },
  title: {
    fontFamily: 'Lato',
    fontSize: '12px',
    fontWeight: '600',
    lineHeight: '1.2rem',
    textAlign: 'left',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: ({ wrapWidth }) => wrapWidth || '209px',
  },
  subTitle: {
    fontFamily: 'Lato',
    fontSize: '10px',
    fontWeight: '500',
    lineHeight: '13.6px',
    textAlign: 'left',
  },
  moreIcon: {
    height: '20px',
    cursor: 'pointer',
  },
  statusText: {
    fontFamily: 'Lato',
    fontSize: '10px',
    fontWeight: '500',
    lineHeight: '13.6px',
    textAlign: 'left',
    color: ({ status }) => (status === 0 ? 'rgba(217, 45, 32, 1)' : 'rgba(2, 122, 72, 1)'),
  },
  checkbox: {
    border: '2px solid #5925DC',
    borderRadius: '4px',
    backgroundColor: 'white',
    cursor: 'pointer',
  },
  '& .checkbox:checked': {
    backgroundColor: '#5925DC',
    borderColor: '#5925DC',
  },
});

const CustomCard = ({
  id,
  checkbox,
  thumbnail,
  staticThumbnail,
  thumbnailSize = '52px',
  title,
  subTitle,
  thirdTitle,
  width,
  height,
  menu,
  status,
  handleChange,
  selected,
  handleMenuItemClick,
  menuItems,
  grey,
  name,
  wrapWidth = '209px',
  disabled = false,
  handleClick = null,
  clicked = false,
}) => {
  const classes = useStyles({ width, height, status, grey, wrapWidth, disabled, thumbnailSize, clicked });
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClickOptions = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Card id={id} className={classes.root} variant="outlined" onClick={handleClick}>
      <CardContent>
        <Grid container direction="row" justifyContent="space-between" alignItems="flex-start" spacing={1}>
          {checkbox && (
            <Grid item>
              <Checkbox
                value={id}
                name={name}
                checked={selected}
                disabled={disabled}
                onChange={handleChange}
                size="small"
                onClick={(e) => e.stopPropagation()}
                sx={{
                  padding: '2px 9px',
                  color: '#5925DC',
                  '&.Mui-checked': {
                    color: disabled ? '#98A2B3' : '#5925DC',
                  },
                  '&.MuiCheckbox-indeterminate': {
                    color: disabled ? '#98A2B3' : '#5925DC',
                  },
                }}
              />
            </Grid>
          )}
          {thumbnail && (
            <Grid item>
              <Image alt="" src={thumbnail || ''} className={classes.thumbnail} />
            </Grid>
          )}
          {staticThumbnail && (
            <Grid item className={classes.thumbnail}>
              {staticThumbnail}
            </Grid>
          )}
          <Grid item xs>
            <Typography variant="h6" component="h6" className={classes.title}>
              {title}
            </Typography>
            <Typography className={classes.subTitle} color="textSecondary" gutterBottom>
              {subTitle}
            </Typography>
            <Typography className={classes.subTitle} color="textSecondary" gutterBottom>
              {thirdTitle}
            </Typography>
          </Grid>

          <Grid item style={{ height: '7vh' }}>
            <Grid
              container
              direction="column"
              justifyContent="space-between"
              alignItems="flex-end"
              style={{ height: '100%' }}
            >
              <Grid item>
                {menu && (
                  <>
                    <MoreVert
                      className={classes.moreIcon}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleClickOptions(e);
                      }}
                    />
                    <CustomMenu
                      id={id}
                      anchorEl={anchorEl}
                      handleClose={handleClose}
                      handleMenuItemClick={handleMenuItemClick}
                      menuItems={menuItems}
                    />
                  </>
                )}
              </Grid>
              <Grid item>
                {status !== undefined && (
                  <Typography className={classes.statusText} color="textSecondary" gutterBottom>
                    {status === 0 ? 'Disabled' : 'Enabled'}
                  </Typography>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default CustomCard;
